<template>
  <div class="service-box">
    <div class="button cta small primary" @click="getServiceList">
      Refresh
    </div>

    <div class="d-flex tables align-start">
      <div class="rsp-box">
        <table class="table-box" cellspacing="1">
          <tr>
            <td colspan="7" class="table-header">
              <div class="th-box">
                <span>Ride Share PRO</span>
                <div class="sv-action-group">
                  <span class="server-action" @click="svAction.list = !svAction.list; svAction.listHolo = false"><i class="fas fa-bars"></i></span>
                  <transition name="slide-fade">
                    <div class="sv-a-options" v-show="svAction.list">
                      <div @click="confirm('Flush Hosts', 'rsp')">Flush Hosts</div>
                      <div @click="confirm('Unstuck DB', 'rsp')">Unstuck DB</div>
                    </div>
                  </transition>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="rsp && !Object.keys(rsp).length">
            <td colspan="7">No record found.</td>
          </tr>
          <tr v-if="rsp && Object.keys(rsp).length" class="col-head">
            <td></td>
            <td>State</td>
            <td>Master</td>
            <td>Slave 1</td>
            <td>Slave 2</td>
            <td>Slave 3</td>
            <td>Location</td>
          </tr>
          <tr v-for="(key, i) in rsp" :key="i">
            <td class="label">
              <i :class="['fas fa-info-circle fa-fw', {active: i === raw.rsp.field}]" @click="toggleRaw(i, key, 'rsp')"></i>
              {{ i }}
            </td>
            <td :class="['value', statusCheck(key, 'error')]"></td>
            <td :class="['value', statusCheck(key, 'master')]"></td>
            <td :class="['value', statusCheck(key, 'slave1')]"></td>
            <td :class="['value', statusCheck(key, 'slave2')]"></td>
            <td :class="['value', statusCheck(key, 'slave3')]"></td>
            <td :class="['value', statusCheck(key, 'location')]"></td>
          </tr>
        </table>

        <pre v-show="raw.rsp.msg" class="raw-pre">{{ raw.rsp.msg }}</pre>
      </div>

      <div class="rsp-box">
        <table class="table-box" cellspacing="1">
          <tr>
            <td colspan="7" class="table-header">
              <div class="th-box">
                <span>Holoholo TNC</span>
                <div class="sv-action-group">
                  <span class="server-action" @click="svAction.listHolo = !svAction.listHolo; svAction.list = false"><i class="fas fa-bars"></i></span>
                  <transition name="slide-fade">
                    <div class="sv-a-options" v-show="svAction.listHolo">
                      <div @click="confirm('Flush Hosts', 'holotnc')">Flush Hosts</div>
                      <div @click="confirm('Unstuck DB', 'holotnc')">Unstuck DB</div>
                    </div>
                  </transition>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="rsp && !Object.keys(rsp).length">
            <td colspan="7">No record found.</td>
          </tr>
          <tr v-if="rsp && Object.keys(rsp).length" class="col-head">
            <td></td>
            <td>State</td>
            <td>Master</td>
            <td>Slave 1</td>
            <td>Slave 2</td>
            <td>Slave 3</td>
            <td>Location</td>
          </tr>
          <tr v-for="(key, i) in holotnc" :key="i">
            <td class="label">
              <i :class="['fas fa-info-circle fa-fw', {active: i === raw.holotnc.field}]" @click="toggleRaw(i, key, 'holotnc')"></i>
              {{ i }}
            </td>
            <td :class="['value', statusCheck(key, 'error')]"></td>
            <td :class="['value', statusCheck(key, 'master')]"></td>
            <td :class="['value', statusCheck(key, 'slave1')]"></td>
            <td :class="['value', statusCheck(key, 'slave2')]"></td>
            <td :class="['value', statusCheck(key, 'slave3')]"></td>
            <td :class="['value', statusCheck(key, 'location')]"></td>
          </tr>
        </table>

        <pre v-show="raw.holotnc.msg" class="raw-pre">{{ raw.holotnc.msg }}</pre>
      </div>

      <!-- <table class="table-box hwtnc" cellspacing="0">
        <tr>
          <td colspan="2" class="table-header">Holoholo TNC</td>
        </tr>
        <tr v-if="holotnc && !Object.keys(holotnc).length">
          <td colspan="2">No record found.</td>
        </tr>
        <tr v-for="(key, i) in holotnc" :key="i">
          <td class="label">{{ i }}</td>
          <td :class="['value', key]">{{key}}</td>
        </tr>
      </table> -->
    </div>

    <hr />

    <div class="button cta small primary" @click="getDBStatus">Refresh DB Stats</div>

    <div class="d-flex tables align-start">
      <table class="table-box full" cellspacing="0">
        <tr>
          <td colspan="5" class="table-header">MAIN</td>
        </tr>
        <tr v-if="!db.main.length">
          <td colspan="5">No record found.</td>
        </tr>
        <tr v-else class="col-head">
          <td>ID</td>
          <td>Host</td>
          <td>Command</td>
          <td>Query</td>
          <td>Time</td>
        </tr>
        <tr v-for="(key, i) in db.main" :key="i" :class="['db-vals', {red:key.time >= 10 && key.query}]">
          <td class="label">{{ key.id }}</td>
          <td class="label">{{ key.host }}</td>
          <td class="label">{{ key.command }}</td>
          <td class="label">{{ key.query }}</td>
          <td class="label">{{ key.time }}</td>
        </tr>
      </table>
      <table class="table-box full" cellspacing="0">
        <tr>
          <td colspan="5" class="table-header">Slave 1</td>
        </tr>
        <tr v-if="!db.slave1.length">
          <td colspan="5">No record found.</td>
        </tr>
        <tr v-else class="col-head">
          <td>ID</td>
          <td>Host</td>
          <td>Command</td>
          <td>Query</td>
          <td>Time</td>
        </tr>
        <tr v-for="(key, i) in db.slave1" :key="i" :class="['db-vals', {red:key.time >= 10 && key.query}]">
          <td class="label">{{ key.id }}</td>
          <td class="label">{{ key.host }}</td>
          <td class="label">{{ key.command }}</td>
          <td class="label">{{ key.query }}</td>
          <td class="label">{{ key.time }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex tables align-start">
      <table class="table-box full" cellspacing="0">
        <tr>
          <td colspan="5" class="table-header">Slave 2</td>
        </tr>
        <tr v-if="!db.slave2.length">
          <td colspan="5">No record found.</td>
        </tr>
        <tr v-else class="col-head">
          <td>ID</td>
          <td>Host</td>
          <td>Command</td>
          <td>Query</td>
          <td>Time</td>
        </tr>
        <tr v-for="(key, i) in db.slave2" :key="i" :class="['db-vals', {red:key.time >= 10 && key.query}]">
          <td class="label">{{ key.id }}</td>
          <td class="label">{{ key.host }}</td>
          <td class="label">{{ key.command }}</td>
          <td class="label">{{ key.query }}</td>
          <td class="label">{{ key.time }}</td>
        </tr>
      </table>
      <table class="table-box full" cellspacing="0">
        <tr>
          <td colspan="5" class="table-header">Slave 3</td>
        </tr>
        <tr v-if="!db.slave3.length">
          <td colspan="5">No record found.</td>
        </tr>
        <tr v-else class="col-head">
          <td>ID</td>
          <td>Host</td>
          <td>Command</td>
          <td>Query</td>
          <td>Time</td>
        </tr>
        <tr v-for="(key, i) in db.slave3" :key="i" :class="['db-vals', {red:key.time >= 10 && key.query}]">
          <td class="label">{{ key.id }}</td>
          <td class="label">{{ key.host }}</td>
          <td class="label">{{ key.command }}</td>
          <td class="label">{{ key.query }}</td>
          <td class="label">{{ key.time }}</td>
        </tr>
      </table>
    </div>

    <div :class="['lr-modal', {'hide': !svAction.show}]">
      <div class="lr-box">
        <div class="lr-alert-msg">
          Are you sure you want to run
          <b>{{ svAction.action }}</b>?
        </div>
        <div class="d-flex justify-space-around btns">
          <a class="button cta small secondary block" @click="svAction.show = false">Cancel</a>
          <a class="button cta small primary block" @click="btnTrigger">Confirm</a>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'failed',
  data () {
    return {
      triggerOnLoad: false,
      holotnc: {},
      rsp: {},
      svAction: {
        list: false,
        listHolo: false,
        show: false,
        action: '',
        target: ''
      },
      raw: {
        rsp: {
          field: '',
          msg: ''
        },
        holotnc: {
          field: '',
          msg: ''
        }
      },
      db: {
        main: [],
        slave1: [],
        slave2: [],
        slave3: []
      }
    }
  },
  computed: {
  },
  methods: {
    checkLoaded () {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true
        this.getServiceList()
        this.getDBStatus()
      }
    },
    getServiceList () {
      let self = this

      self.$store.commit('global/setLoaderData', {show: true})
      self.holotnc = {}
      self.rsp = {}
      self.$sdk.get('utils/check', {}, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.holotnc = r.holotnc
        self.rsp = r.rsp
        // self.checkHoloStatus()
      }, '')
    },
    checkHoloStatus () {
      let self = this

      self.$sdk.get('utils/services', {}, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.holotnc = r.holotnc
        // self.rsp = r.rsp
      }, '')
    },
    statusCheck (data, field) {
      if (field === 'error') return data.error ? 'red' : 'green'
      else {
        if (!data.db) return 'black'
        if (data.db[field]) return data.db[field].startsWith('8') ? 'green' : 'red'
        if (!data.db[field]) return 'black'
      }
    },
    toggleRaw (field, msg, type) {
      if (this.raw[type].field === field) {
        this.raw[type].field = ''
        this.raw[type].msg = ''
        return
      }
      this.raw[type].field = field
      this.raw[type].msg = msg
    },
    getDBStatus () {
      let self = this

      self.db = {
        main: [],
        slave1: [],
        slave2: [],
        slave3: []
      }
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('utils/dbstats', {}, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }

        self.db = {
          main: r.main || [],
          slave1: r.slave1 || [],
          slave2: r.slave2 || [],
          slave3: r.slave3 || []
        }
      }, '')
    },
    confirm (x, type) {
      this.svAction.action = x
      this.svAction.target = type
      this.svAction.show = true
      this.svAction.list = false
      this.svAction.listHolo = false
    },
    btnTrigger () {
      this.svAction.show = false
      if (this.svAction.action === 'Flush Hosts') this.flushHost(this.svAction.target)
      if (this.svAction.action === 'Unstuck DB') this.unstuckDB(this.svAction.target)
    },
    flushHost (x) {
      let self = this
      if (x === 'rsp') {
        self.$sdk.get('/utils/flushhosts', {}, r => {
          self.$store.commit('global/setLoaderData', {show: false})
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `<b>${self.svAction.action}</b> SUCCESS!`
          })
        }, '')
      }
      if (x === 'holotnc') {
        self.$store.commit('global/setLoaderData', {show: true})
        self.$sdk.get2('https://hl-tnc-api.ridesharepro.com/utils/flushhosts', {
          role: 'api',
          cmd: 'system.flush'
        }, r => {
          self.$store.commit('global/setLoaderData', {show: false})
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `<b>${self.svAction.action}</b> SUCCESS!`
          })
        })
      }
    },
    unstuckDB (x) {
      let self = this
      if (x === 'rsp') {
        self.$sdk.get('/utils/unstuck', {}, r => {
          self.$store.commit('global/setLoaderData', {show: false})
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `<b>${self.svAction.action}</b> SUCCESS!`
          })
        }, '')
      }
      if (x === 'holotnc') {
        self.$store.commit('global/setLoaderData', {show: true})
        self.$sdk.get2('https://hl-tnc-api.ridesharepro.com/utils/unstuck', {}, r => {
          self.$store.commit('global/setLoaderData', {show: false})
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `<b>${self.svAction.action}</b> SUCCESS!`
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.service-box{
  padding: 15px;
}

.tables{
  gap: 10px;
  margin: 10px 0 20px;
}

.rsp-box{
  max-width: 650px;
}
.table-box{
  width: 100%;
  max-width: 650px;
  border: 1px solid #333;
  background: #fafafa;
  border-radius: 4px;
  font-size: 14px;

  &.hwtnc{
    max-width: 300px;
  }
  .table-header{
    background: #333;
    color: #fff;
    padding: 5px;
    font-size: 18px;
    font-weight: 600;
  }
  .col-head{
    font-size:12px;
    letter-spacing: .6px;
    text-align: center;

    td{
      border-bottom: 1px solid #333;
      background: #e9f2ff;
      font-weight: 600;
    }
  }
  .th-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }
  .sv-action-group{
    position: relative;
  }
  .sv-a-options{
    position:absolute;
    top: calc(100% + 5px);
    right: 0;
    background: #fff;
    color: #333;
    box-shadow: 1px 1px 4px;
    width: 100px;

    div{
      font-size: 14px;
      padding: 8px 7px;
      line-height: 1;
      letter-spacing: .5px;
      border-bottom: 1px solid #ddd;
      cursor: pointer;

      &:hover{
        background: #f3f3f3;
      }
      &:last-child{
        border-bottom: none;
      }
    }
  }
  .server-action{
    font-size: 14px;
    background: #0d79f2;
    padding: 4px 12px;
    border-radius: 4px;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, .9);
    cursor: pointer;

    &:hover{
      background: #2798e9;
    }
  }

  .fa-info-circle{
    cursor: pointer;
    color: #a8aeb3;
    font-size: 16px;
    vertical-align: -1px;
    
    &.active{
      color: #2798e9;
    }
  }

  // tr:nth-child(odd) td:not(.table-header){
  //   background: #f3f3f3;
  // }
  // tr:hover td:not(.table-header){
  //   background: #fffbc5!important;
  // }
  td{
    padding: 5px 8px;
  }

  .label{
    text-transform: capitalize;
    color: #444;
    letter-spacing: .5px;
  }
  .value{
    text-align: right;
    font-weight: 600;
    color: #f00;

    &.OK{
      color: #48cf28;
    }
    &.red{
      background: #ed5a5a!important;
    }
    &.green{
      background: #4ae171 !important;
    }
    &.black{
      background: transparent!important;
    }
  }
}
.raw-pre{
  background: #ebebeb;
  padding: 10px;
  overflow: auto;
  height: 200px;
  font-size: 13px;
  line-height: 1.3;
}

hr{
  margin: 30px 0;
}

.db-vals{
  text-align: center;

  &.red{
    background: #ffa6a6!important;
  }
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.15s ease-in;
  -moz-transition: all 0.15s ease-in;
  -o-transition: all 0.15s ease-in;
  transition: all 0.15s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
  .btns{
    gap: 10px;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  min-width: 300px;
  max-width: 500px;
}

.lr-alert-msg{
  margin-bottom: 20px;
  color: #45505b;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminCode/services.vue